import React from 'react';
// ?raw 轉 data URI:內嵌模式下 dev 的 /src/... 資源網址不在主系統 rewrite 範圍(只轉 /schedule/*),<img> 會 404
import rabbitSvg from './rabbit.svg?raw';

const rabbitUrl = `data:image/svg+xml,${encodeURIComponent(rabbitSvg)}`;
import './MidAutumnEffect.scss';

/**
 * 中秋節特效 - 滿月 + 玉兔 + 星空閃爍
 */
const MidAutumnEffect = () => {
  return (
    <div className="mid-autumn-effect" aria-hidden="true">
      <div className="stars">
        {[...Array(30)].map((_, i) => (
          <div key={i} className="star"></div>
        ))}
      </div>

      <div className="moon">
        <img className="rabbit" src={rabbitUrl} alt="" />
      </div>
    </div>
  );
};

export default MidAutumnEffect;
